import {DatabaseURL} from "../../App";
import {errorActions} from "../ErrorHandler/errorHandler";
import api from "../../util/api";

export const settingsActionTypes = {
    getCompanyUsers: "getCompanyUsers",
    getSettingTracks: "getSettingTracks",
    getSettingTopics: "getSettingTopics",
    getMetricsTracks: "getMetricsTracks",
    getTrackFeaturesRanking: "getTrackFeaturesRanking",
    getMetricsNetgraphData: "getMetricsNetgraphData",
    getMetricsNetgraphConfig: "getMetricsNetgraphConfig",
    getMetricsInsights: "getMetricsInsights",
    getPlans: "getPlans",
    //loaders:
    setIsLoadingGeneralSettings: "setIsLoadingGeneralSettings",
    setLoaderMetricsConcepts: "setLoaderMetricsConcepts",
    getMetricsConcepts: "getMetricsConcepts",
    setMetricsTableLoading: "setMetricsTableLoading",
    setMetricsNetgraphDataLoading: "setMetricsNetgraphDataLoading",
    setIsLoadingSettingTracks: "setIsLoadingSettingTracks",
    setIsLoadingSettingTopics: "setIsLoadingSettingTopics",
    setIsLoadingSettingsUsers: "setIsLoadingSettingsUsers",
    setPlansLoading: "setPlansLoading",
    //reset:
    clearSettings: "clearSettings",
    //setters:
    setLogo: "setLogo",
    setHomePic: "setHomePic",
};

const initialSettings = {
    pageTitle: "",
    googleAnalyticsID: "",
    loginPic: "",
    homePic: "",
    corporativeLogo: "",
    directPublish: "",
};

const initialSettingsState = {
    settings: initialSettings,
    settingsTracks: [],
    settingsTopics: [],
    companyUsers: [],
    trackFeaturesRanking: [],
    metricsNetgraphData: [],
    metricsInsights: [],
    metricsTracks: [],
    metricsConcepts: {},
    plans: {},
    //errors:
    tracksError: {},
    topicsError: {},
    usersError: {},
    metricsTracksError: {},
    netgraphError: {},
    metricsConceptsError: {},
    plansError: {},
    //loaders:
    isLoadingGeneralSettings: true,
    isLoadingSettingsUsers: true,
    isLoadingSettingTracks: true,
    isLoadingSettingTopics: true,
    isLoadingConcepts: true,
    isLoadingMetricsNetgraphData: true,
    isLoadingMetricsTable: true,
    isLoadingPlans: true,
};

export const settingsReducer = (state = initialSettingsState, action) => {
    switch (action.type) {
        case settingsActionTypes.getCompanyUsers: {
            const {companyUsers, usersError} = action.payload;
            return {...state, companyUsers, usersError};
        }

        case settingsActionTypes.getSettingTracks: {
            const {settingsTracks, tracksError} = action.payload;

            return {...state, settingsTracks, tracksError};
        }

        case settingsActionTypes.getSettingTopics: {
            const {settingsTopics, topicsError} = action.payload;

            return {...state, settingsTopics, topicsError};
        }

        case settingsActionTypes.getMetricsTracks: {
            const {metricsTracks, metricsTracksError} = action.payload;

            return {...state, metricsTracks, metricsTracksError};
        }

        case settingsActionTypes.getMetricsConcepts: {
            const {metricsConcepts, metricsConceptsError} = action.payload;

            return {...state, metricsConcepts, metricsConceptsError};
        }

        case settingsActionTypes.getTrackFeaturesRanking: {
            const {trackFeaturesRanking} = action.payload;

            return {...state, trackFeaturesRanking};
        }

        case settingsActionTypes.getMetricsNetgraphData: {
            const {metricsNetgraphData, netgraphError} = action.payload;

            return {...state, metricsNetgraphData, netgraphError};
        }

        case settingsActionTypes.getMetricsNetgraphConfig: {
            const {metricsNetgraphConfig} = action.payload;

            return {...state, metricsNetgraphConfig};
        }

        case settingsActionTypes.getMetricsInsights: {
            const {metricsInsights} = action.payload;

            return {...state, metricsInsights};
        }

        case settingsActionTypes.getPlans: {
            const {plans, plansError} = action.payload;

            return {...state, plans, plansError};
        }

        //loaders:

        case settingsActionTypes.setIsLoadingGeneralSettings: {
            const {isLoadingGeneralSettings} = action.payload;

            return {...state, isLoadingGeneralSettings};
        }

        case settingsActionTypes.setMetricsNetgraphDataLoading: {
            const {isLoadingMetricsNetgraphData} = action.payload;

            return {...state, isLoadingMetricsNetgraphData};
        }

        case settingsActionTypes.setMetricsTableLoading: {
            const {isLoadingMetricsTable} = action.payload;

            return {...state, isLoadingMetricsTable};
        }

        case settingsActionTypes.setIsLoadingSettingTracks: {
            const {isLoadingSettingTracks} = action.payload;

            return {...state, isLoadingSettingTracks};
        }

        case settingsActionTypes.setIsLoadingSettingTopics: {
            const {isLoadingSettingTopics} = action.payload;

            return {...state, isLoadingSettingTopics};
        }

        case settingsActionTypes.setIsLoadingSettingsUsers: {
            const {isLoadingSettingsUsers} = action.payload;

            return {...state, isLoadingSettingsUsers};
        }

        case settingsActionTypes.setLoaderMetricsConcepts: {
            const {isLoadingConcepts} = action.payload;

            return {...state, isLoadingConcepts};
        }

        case settingsActionTypes.setPlansLoading: {
            const {isLoadingPlans} = action.payload;

            return {...state, isLoadingPlans};
        }

        //reset:
        case settingsActionTypes.clearSettings: {
            return initialSettingsState;
        }

        //setters:
        case settingsActionTypes.setLogo: {
            const {corporativeLogo} = action.payload;

            return {...state, settings: {...state.settings, corporativeLogo}};
        }

        case settingsActionTypes.setHomePic: {
            const {homePic} = action.payload;

            return {...state, settings: {...state.settings, homePic}};
        }

        default:
            return state;
    }
};

export const settingsActions = {
    getSettingTracks: () => dispatch => {
        dispatch({
            type: settingsActionTypes.setIsLoadingSettingTracks,
            payload: {isLoadingSettingTracks: true},
        });

        return api
            .get(`v2/api/settings/tracks`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
            })
            .then(({data: {data = [], message = [{}]}}) => {
                const tracksWithNewImgsDate = data.map(track => {
                    const picture = track.picture || `/media/dummy/dummy-img.jpg`;
                    const header = track.header || `/media/dummy/dummy-img.jpg`;
                    return {...track, picture, header};
                });
                dispatch({
                    type: settingsActionTypes.setIsLoadingSettingTracks,
                    payload: {isLoadingSettingTracks: false},
                });
                dispatch({
                    type: settingsActionTypes.getSettingTracks,
                    payload: {
                        settingsTracks: tracksWithNewImgsDate,
                        tracksError: message[0],
                    },
                });
            })
            .catch(err => {
                dispatch({
                    type: settingsActionTypes.setIsLoadingSettingTracks,
                    payload: {isLoadingSettingTracks: false},
                });
                dispatch({
                    type: settingsActionTypes.getSettingTracks,
                    payload: {
                        tracksError: {type: "danger", text: err.message},
                    },
                });
            });
    },

    getMetricsTracks: () => dispatch => {
        return api
            .get(`v2/api/settings/metrics/tracks`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
            })
            .then(({data: {data = [], message = [{}]}}) => {
                const availableTracks = data.find(track => track.id !== null);
                if (!availableTracks) {
                    dispatch({
                        type: settingsActionTypes.setMetricsNetgraphDataLoading,
                        payload: {isLoadingMetricsNetgraphData: false},
                    });
                    dispatch({
                        type: settingsActionTypes.setLoaderMetricsConcepts,
                        payload: {isLoadingConcepts: false},
                    });
                    dispatch({
                        type: settingsActionTypes.getMetricsTracks,
                        payload: {
                            metricsTracks: data,
                            metricsTracksError: {text: "No tracks"},
                        },
                    });
                    dispatch({
                        type: settingsActionTypes.getMetricsConcepts,
                        payload: {
                            metricsConcepts: {},
                            metricsConceptsError: {text: "No tracks"},
                        },
                    });
                } else {
                    dispatch({
                        type: settingsActionTypes.getMetricsTracks,
                        payload: {metricsTracks: data, metricsTracksError: message[0]},
                    });
                }
            })
            .catch(err => {
                dispatch({
                    type: settingsActionTypes.setMetricsNetgraphDataLoading,
                    payload: {isLoadingMetricsNetgraphData: false},
                });
                dispatch({
                    type: settingsActionTypes.getMetricsTracks,
                    payload: {metricsTracks: [], metricsTracksError: {text: err.message}},
                });
            });
    },

    getMetricsConcepts: (language) => dispatch => {
        return api
            .get(`v2/api/settings/metrics/graph/features`, {
                method: "GET",
                params: {language},
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
            })
            .then(({data: {data = {}, message = [{}]}}) => {
                dispatch({
                    type: settingsActionTypes.setLoaderMetricsConcepts,
                    payload: {isLoadingConcepts: false},
                });
                dispatch({
                    type: settingsActionTypes.getMetricsConcepts,
                    payload: {
                        metricsConcepts: data,
                        metricsConceptsError: message[0],
                    },
                });
            })
            .catch(err => {
                dispatch({
                    type: settingsActionTypes.setLoaderMetricsConcepts,
                    payload: {isLoadingConcepts: false},
                });
                dispatch({
                    type: settingsActionTypes.getMetricsConcepts,
                    payload: {
                        metricsConceptsError: {type: "danger", text: err.message},
                    },
                });
            });
    },

    getMetricsInsights: trackId => dispatch => {
        return api
            .get(`v2/api/settings/metrics/${trackId}/netgraph/features`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
            })
            .then(({data}) => {
                dispatch({
                    type: settingsActionTypes.getMetricsInsights,
                    payload: {
                        metricsInsights: data.data || [],
                    },
                });
            })
            .catch(err => dispatch(errorActions.setErrorMessage(err.message)));
    },

    getTrackFeaturesRanking: (trackId, language) => dispatch => {
        dispatch({
            type: settingsActionTypes.setMetricsTableLoading,
            payload: {isLoadingMetricsTable: true},
        });
        return api
            .get(`v2/api/settings/metrics/${trackId}/ranking`, {
                method: "GET",
                params: {language},
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
            })
            .then(({data}) => {
                dispatch({
                    type: settingsActionTypes.setMetricsTableLoading,
                    payload: {isLoadingMetricsTable: false},
                });
                dispatch({
                    type: settingsActionTypes.getTrackFeaturesRanking,
                    payload: {trackFeaturesRanking: data.data},
                });
            })
            .catch(err => {
                dispatch({
                    type: settingsActionTypes.setMetricsTableLoading,
                    payload: {isLoadingMetricsTable: false},
                });
                dispatch(errorActions.setErrorMessage(err.message));
            });
    },

    getMetricsNetgraphData: (trackId, language) => dispatch => {
        dispatch({
            type: settingsActionTypes.setMetricsNetgraphDataLoading,
            payload: {isLoadingMetricsNetgraphData: true},
        });
        return api
            .get(`v2/api/settings/metrics/${trackId}/netgraph`, {
                method: "GET",
                params: {language},
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
            })
            .then(({data: {data = [], message = [{}]}}) => {
                dispatch({
                    type: settingsActionTypes.getMetricsNetgraphData,
                    payload: {
                        metricsNetgraphData: data && data.length ? data : {},
                        netgraphError: message[0],
                    },
                });
                setTimeout(() => {
                    //shouln't need settimeout with redux thunks
                    dispatch({
                        type: settingsActionTypes.setMetricsNetgraphDataLoading,
                        payload: {isLoadingMetricsNetgraphData: false},
                    });
                }, 500);
            })
            .catch(err => {
                dispatch({
                    type: settingsActionTypes.setMetricsNetgraphDataLoading,
                    payload: {isLoadingMetricsNetgraphData: false},
                });
                dispatch({
                    type: settingsActionTypes.getMetricsNetgraphData,
                    payload: {netgraphError: {type: "danger", text: err.message}},
                });
            });
    },

    getMetricsNetgraphConfig: type => dispatch => {
        return api
            .get(`${DatabaseURL}/api/component/${type}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
            })
            .then(({data}) => {
                dispatch({
                    type: settingsActionTypes.getMetricsNetgraphConfig,
                    payload: {metricsNetgraphConfig: data.data[0].config},
                });
            })
            .catch(err => {
                console.error("Error on netgraph config data retriving");
                // dispatch(errorActions.setErrorMessage('Error on netgraph config data retriving'));
            });
    },

    getPlans: () => dispatch => {
        dispatch({
            type: settingsActionTypes.setPlansLoading,
            payload: {isLoadingPlans: true},
        });
        return api
            .get(`v2/api/settings/limits`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
            })
            .then(({data: {data = [], message = [{}]}}) => {
                dispatch({
                    type: settingsActionTypes.setPlansLoading,
                    payload: {isLoadingPlans: false},
                });

                dispatch({
                    type: settingsActionTypes.getPlans,
                    payload: {
                        plans: data,
                        plansError: message[0],
                    },
                });
            })
            .catch(err => {
                dispatch({
                    type: settingsActionTypes.setPlansLoading,
                    payload: {isLoadingPlans: false},
                });
                dispatch({
                    type: settingsActionTypes.getPlans,
                    payload: {plansError: {type: "danger", text: err.message}},
                });
            });
    },

    setLogo: corporativeLogo => dispatch => {
        dispatch({
            type: settingsActionTypes.setLogo,
            payload: {corporativeLogo},
        });
    },

    setHomePic: homePic => dispatch => {
        dispatch({
            type: settingsActionTypes.setHomePic,
            payload: {homePic},
        });
    },

    clearSettings: () => dispatch =>
        dispatch({
            type: settingsActionTypes.clearSettings,
            payload: {},
        }),
};
